"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UploadcareFile = void 0;
var _uploads = require("@prezly/uploads");
var _constants = require("../constants.cjs");
var _normalizeFileName = require("./normalizeFileName.cjs");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var UploadcareFile = exports.UploadcareFile = /*#__PURE__*/function () {
  function UploadcareFile(_ref) {
    var _this = this;
    var filename = _ref.filename,
      mimeType = _ref.mimeType,
      size = _ref.size,
      uuid = _ref.uuid;
    _classCallCheck(this, UploadcareFile);
    _defineProperty(this, "cdnUrl", void 0);
    _defineProperty(this, "downloadUrl", void 0);
    _defineProperty(this, "filename", void 0);
    _defineProperty(this, "mimeType", void 0);
    _defineProperty(this, "size", void 0);
    _defineProperty(this, "uuid", void 0);
    _defineProperty(this, "toPrezlyStoragePayload", function () {
      return {
        version: 2,
        uuid: _this.uuid,
        filename: _this.filename,
        mime_type: _this.mimeType,
        size: _this.size
      };
    });
    this.uuid = uuid;
    this.filename = filename;
    this.size = size;
    this.mimeType = mimeType;
    this.cdnUrl = "".concat(_constants.UPLOADCARE_CDN_URL, "/").concat(uuid, "/").concat(encodeURIComponent(this.filename));
    this.downloadUrl = "".concat(_constants.UPLOADCARE_CDN_URL, "/").concat(uuid, "/-/inline/no/").concat((0, _normalizeFileName.normalizeFileName)(this.filename));
  }
  return _createClass(UploadcareFile, [{
    key: "isImage",
    get: function get() {
      return this.mimeType.startsWith('image/');
    }
  }], [{
    key: "createFromPrezlyStoragePayload",
    value: function createFromPrezlyStoragePayload(payload) {
      return new UploadcareFile({
        uuid: payload.uuid,
        filename: payload.filename,
        mimeType: payload.mime_type,
        size: payload.size
      });
    }
  }, {
    key: "createFromUploadcareWidgetPayload",
    value: function createFromUploadcareWidgetPayload(payload) {
      return new UploadcareFile({
        uuid: payload.uuid,
        filename: payload.name,
        mimeType: payload.mimeType,
        size: payload.size
      });
    }
  }, {
    key: "isPrezlyStoragePayload",
    value: function isPrezlyStoragePayload(payload) {
      return (0, _uploads.isUploadedFile)(payload);
    }
  }]);
}();